import * as React from "react";
const SvgChurch = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M12.02 8.028a1 1 0 0 0-1 1v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1.5a1 1 0 0 0-1-1Z"
      fill="currentColor"
    />
    <path
      d="M12.75 1.75a.75.75 0 0 0-1.5 0v1.635L5.788 7.659a.75.75 0 0 0-.288.591v2.618l-2.191 1.594a.75.75 0 0 0-.309.606v7.182c0 .966.784 1.75 1.75 1.75h14.5A1.75 1.75 0 0 0 21 20.25v-7.182a.75.75 0 0 0-.309-.606L18.5 10.868V8.25a.75.75 0 0 0-.288-.59L12.75 3.384V1.75ZM7.192 20.5H7V8.615l5-3.913 5 3.913V20.5h-2v-4.423C15 14.4 13.68 13 12 13s-3 1.401-3 3.077V20.5H7.192ZM5.5 12.723V20.5h-.75a.25.25 0 0 1-.25-.25v-6.8l1-.727ZM19.25 20.5h-.75v-7.777l1 .727v6.8a.25.25 0 0 1-.25.25Zm-7.25-6c.805 0 1.5.682 1.5 1.577V20.5h-3v-4.423c0-.895.695-1.577 1.5-1.577Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgChurch;
